import { effect, inject, Injectable, signal } from '@angular/core';
import { catchError, of } from 'rxjs';
import { LoadingService } from './loading.service';
import { TopicService } from './topic.service';
import { TopicsBySubjectResponse } from '../models/api/topics.model';

@Injectable({
	providedIn: 'root'
})
export class ParamsService {
	protected loadingService = inject(LoadingService);
	protected topicService = inject(TopicService);

	subjectId = signal<number | undefined>(undefined);
	topicsBySubject = signal<TopicsBySubjectResponse | undefined | null>(undefined);
	chatId = signal<number | null>(null);
	topicIds = signal<number[] | null>(null);

	private topicsEffect = effect(
		() => {
			const topicsBySubject = this.topicsBySubject();
			if (topicsBySubject) {
				this.topicIds.set(topicsBySubject.topics.map((topic) => topic.id));
			} else {
				this.topicIds.set(null);
				this.chatId.set(null);
			}
		},
		{ allowSignalWrites: true }
	);

	getTopicsBySubject(subjectId: number) {
		this.loadingService.loadingTopics.set(true);
		this.topicService
			.getTopicsBySubject(subjectId)
			.pipe(
				catchError(() => {
					return of(null);
				})
			)
			.subscribe((topics) => {
				this.loadingService.loadingTopics.set(false);
				this.subjectId.set(topics ? subjectId : undefined);
				this.topicsBySubject.set(topics);
			});
	}
}
